import script from "./FooterUnicefbelgique.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterUnicefbelgique.vue?vue&type=script&setup=true&lang=js"

import "./FooterUnicefbelgique.vue?vue&type=style&index=0&id=795996bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-795996bc"]])

export default __exports__